<template>
  <v-container class="grey lighten-5" fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Szczegóły płatności
          </v-card-title>
          <v-card-text>
            <TransactionAddEdit
                :id="this.id"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TransactionAddEdit from "@/components/transactions/TransactionAddEdit";

export default {
  components: {
    TransactionAddEdit,
  },
  props: {
    id: {
      type: [String],
      required: true,
    }
  },
}
</script>